<template>
  <div class="home">
    <!-- 头部大图 -->
    <div class="head-img">
      <h3 class="animate__animated wow animate__fadeInLeft">
        Providing innovative services and quality products for Patients with
        renal disease
      </h3>
      <button
        class="Undme animate__animated wow animate__fadeInLeft"
        @click="RouterChangeTo('About')"
      >
        <span>About Us</span><i class="el-icon-right"></i>
      </button>
      <ul class="infobox">
        <li id="one">
          <h2>30000 +</h2>
          <p>Patients</p>
        </li>
        <li>
          <h2>232</h2>
          <p>Experts</p>
        </li>
        <li>
          <h2>512</h2>
          <p>Hospitals</p>
        </li>
        <li>
          <h2>208</h2>
          <p>Partners</p>
        </li>
      </ul>
    </div>
    <!-- 淡入展示 -->
    <div class="sketch">
      <div class="sketch-box">
        <div
          class="sketch-box-img animate__animated wow animate__fadeInLeft"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/518C385D5CE14B57B137F365496EDBB9-6-2.png"
            alt=""
          />
        </div>
        <div
          class="sketch-box-text animate__animated wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div class="top">
            <h2>Innovative Service</h2>
          </div>
          <div class="main main2">Commercial Planning<br />Business Operation</div>
          <div class="bottom">
            <button @click="RouterChangeTo('Innovate')">
              More <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-text text2 animate__animated wow animate__fadeInLeft"
          data-wow-duration="1s"
        >
          <div class="top toptwo">
            <h2>Business Network</h2>
          </div>
          <div class="main maintwo">
            Integrated Marketing<br />Win-Win Cooperation
          </div>
          <div class="bottom">
            <button @click="RouterChangeTo('Business')">
              More <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div
          class="sketch-box-img animate__animated wow animate__fadeInRight"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/DC704271794E44C0B18E4DB36A667CD8-6-2.png"
            alt=""
          />
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-img animate__animated wow animate__fadeInLeft"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/BF0713CA242940EAB3CF837F9C63F007-6-2.png"
            alt=""
          />
        </div>
        <div
          class="sketch-box-text animate__animated wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div class="top">
            <h2>Industrial Production</h2>
          </div>
          <div class="main main2">Quality Life<br />Quality Water</div>
          <div class="bottom">
            <button @click="RouterChangeTo('Industry')">
              More <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-text text2 animate__animated wow animate__fadeInLeft"
        >
          <div class="top toptwo">
            <h2>Medical Training</h2>
          </div>
          <div class="main maintwo">
            Academic Promotion<br />Professional Training
          </div>
          <div class="bottom">
            <button @click="RouterChangeTo('Science')">
              More <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div class="sketch-box-img animate__animated wow animate__fadeInRight">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/AEC2485981104FBB94C6F376C2146E27-6-2.png"
            alt=""
          />
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-img animate__animated wow animate__fadeInLeft"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/E66F592A44C7490F842357B3AFA31C0D-6-2.png"
            alt=""
          />
        </div>
        <div
          class="sketch-box-text animate__animated wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div class="top top2">
            <h2>Information Platform</h2>
          </div>
          <div class="main main2">Cloud Computing<br />AI<br />IOT</div>
          <div class="bottom">
            <button @click="RouterChangeTo('News')">
              More <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 专家团队 -->
    <div class="team-box animate__animated wow animate__fadeInUp">
      <div class="title">
        <h2>Team of experts</h2>
        <!-- <p>EXPERT TEAM</p> -->
      </div>
      <div class="main">
        <div class="main-left">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/B1713C66D7B4424C9D40A28D9580CAEC-6-2.png"
            alt=""
          />
        </div>
        <div class="main-right">
          <div class="team-infobox">
            <div class="icon">
              <img src="../assets/image/home/97.webp" alt="" />
            </div>
            <h3>37</h3>
            <p>Members of national academic team</p>
          </div>
          <div class="team-infobox gl">
            <div class="icon">
              <img src="../assets/image/home/99.webp" alt="" />
            </div>
            <h3>45</h3>
            <p>Members of Provincial Academic Team</p>
          </div>
          <div class="team-infobox">
            <div class="icon">
              <img src="../assets/image/home/98.webp" alt="" />
            </div>
            <h3>150</h3>
            <p>Chief physician of local center</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partner animate__animated wow animate__fadeInUp">
      <div class="title">
        <h2>Partners</h2>
      </div>
      <div class="partner-menu">
        <!-- 移动端 -->
        <div class="select-menu">
          <el-select v-model="value" placeholder="请选择" @change="toSwitch">
            <el-option
              v-for="item in partnerMenu"
              :key="item.id"
              :label="item.name"
              :value="item.title"
            >
            </el-option>
          </el-select>
        </div>
        <!-- PC端 -->
        <ul>
          <li
            @click="toSwitch(item)"
            v-for="item in partnerMenu"
            :key="item.id"
            :id="item.id === glID ? 'homegl' : ''"
          >
            <div class="icon" v-if="item.id !== glID">
              <img :src="item.icon" alt="" />
            </div>
            <div class="text">{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <ul class="partner-box">
        <li
          :class="glID == 1 || value == 'government' ? 'width' : ''"
          v-for="(item, index) in partnerMenuList"
          :key="index"
        >
          <img :src="item" alt="" />
        </li>
      </ul>
      <div class="PCpage" v-if="glID === 5 || value == 'hospital'">
        <span :class="hospitalGL == 1 ? 'gl' : ''" @click="hospitalChange(1)"
          >1</span
        >
        <span :class="hospitalGL == 2 ? 'gl' : ''" @click="hospitalChange(2)"
          >2</span
        >
      </div>
      <div class="bufen">-{{ message }}-</div>
    </div>
    <!-- 核心团队 -->
    <div class="team">
      <div class="title">
        <h2>Main Members</h2>
      </div>
      <div class="teamcontent">
        <div class="box">
          <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/54EF01B24F8B4C608737FCACEDB4C377-6-2.png" alt="" />
          <div class="tit">Xu XiaoDong <span>Business Partner</span></div>
        </div>
        <div class="box">
          <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/397F3C97B74745CA9EE0405FC6B4C712-6-2.png" alt="" />
          <div class="tit">Chen ShuangMing <span>Business Partner</span></div>
        </div>
      </div>
      <div class="teamcontentIOS">
        <div class="box">
          <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/54EF01B24F8B4C608737FCACEDB4C377-6-2.png" alt="" />
          <div class="tit">Xu XiaoDong <span>Business Partner</span></div>
        </div>
        <div class="box">
          <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/397F3C97B74745CA9EE0405FC6B4C712-6-2.png" alt="" />
          <div class="tit">Chen ShuangMing <span>Business Partner</span></div>
        </div>
      </div>
      <div class="pclunbo">
        <el-carousel trigger="click" :autoplay="false" arrow="always">
          <el-carousel-item v-for="(item, index) in teamList" :key="index">
            <div class="pic">
              <h2>{{ item.text }}</h2>
              <img :src="item.pic" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="ioslunbo">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in IosteamList"
              :key="index"
            >
              <div class="pic">
                <div class="title">{{ item.title }}</div>
                <ul class="image">
                  <li v-for="(item2, index) in item.picList" :key="index">
                    <img :src="item2.pic" />
                    <div class="tit">
                      {{ item2.name }}<span>{{ item2.position }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 资质荣誉 -->
    <div class="zizhi animate__animated wow animate__fadeInUp">
      <div class="title">
        <h3>Credentials</h3>
      </div>
      <div class="lunbo">
        <el-carousel arrow="always" trigger="click" :autoplay="false">
          <el-carousel-item v-for="(item, index) in lunboLists" :key="index">
            <img :src="item" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="lunbo-ios">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in lunboLists" :key="index">
               <img :src="item" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 底部标语 -->
    <div class="footer-title animate__animated wow animate__fadeIn">
      <div class="title">
        Professional medical services, with the best solution
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 局部引入swiper
import WOW from "../../node_modules/wowjs/dist/wow";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
export default {
  data() {
    return {
      message: "Partial display",
      lunboLists: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D62DE6F2314A4A8C82DA6683978F4502-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/590DBA16A6C84606B650702E42D2614E-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/21D451BF8FA94236B2BFD348EA5D7B16-6-2.png",
      ],
      value: "Hospitals",
      // 管理团队
      IosteamList: [
        {
          title: "Team Management",
          picList: [
            {
              name: "Yu Ziliang",
              position: "Deputy General Manger",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/A88580DD54A9498594D497ADF0BD94D5-6-2.png",
            },
            {
              name: "Wan Wei",
              position: "Deputy General Manger",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/0F27A2F7E3344CEA838E44E67C36A3C4-6-2.png",
            },
            {
              name: "Sun Jian",
              position: "Deputy General Manger",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9ECE16552BC04D07BD45520A8A881A81-6-2.png",
            },
          ],
        },
        {
          title: "Director Team",
          picList: [
            {
              name: "Liu Xiaoyan",
              position: "Sales Director",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2A15C43693974FFB8DA0775DA2E146EC-6-2.png",
            },
            // {
            //   name: "Zhang Bin",
            //   position: "Medical Director",
            //   pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/3BA6CEDF8D5B42A6A2EFE06D333C0F4A-6-2.png",
            // },
            {
              name: "Zhang Shixia",
              position: "Procurement Director",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/85B32926680B44E0BE3BDA7DADBD8481-6-2.png",
            },
            {
              name: "Lin Xinru",
              position: "Info Director",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/004EF066EACF416B9E14346E9015C7AF-6-2.png",
            },
            // {
            //   name: "Lu zhiwei",
            //   position: "Sale Director",
            //   pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D6833F7B96344912B17535C2C4839B89-6-2.png",
            // },
          ],
        },
        {
          title: "Division Manager",
          picList: [
            {
              name: "Li Juan",
              position: "Office Chief",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/161DEFA2F7E04C78AAB1273F4563F966-6-2.png",
            },
            {
              name: "Liu Xiang",
              position: "Manager of Engineering Management Department",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2EF656E023C24D3CA718F9F7963EABC6-6-2.png",
            },
            {
              name: "Jin Tao",
              position: "Finance Manager",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F5834A3C8EAF4AEB8421BDDD78DCB950-6-2.png",
            },
          ],
        },
      ],
      teamList: [
        {
          pic:"https://yyt-ows.oss-cn-beijing.aliyuncs.com/D10722E2AB234936B8383AFFC56D87C7-6-2.png",
          text: "Team Management",
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/C1CBB6E8953F42B5A6D6345DD98395A1-6-2.png",
          text: "Director Team",
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/7C794D5C33AD4D90857141844E2E7DA0-6-2.png",
          text: "Division Manager",
        },
      ],
      partnerMenu: [
        {
          name: "Hospitals",
          icon: require("../assets/image/home/228.webp"),
          id: 5,
          title: "hospital",
        },
        {
          name: "Companies",
          icon: require("../assets/image/home/1112.webp"),
          id: 4,
          title: "manufactor",
        },
        {
          name: "Factories",
          icon: require("../assets/image/home/160.webp"),
          id: 3,
          title: "enterprise",
        },
        {
          name: "Agencies",
          icon: require("../assets/image/home/156.webp"),
          id: 2,
          title: "mechanism",
        },
      ],
      glID: 5,
      hospitalGL: 1,
      partnerMenuList: [
        require("../assets/image/home/hospital/4.png"),
        require("../assets/image/home/hospital/2.png"),
        require("../assets/image/home/hospital/3.png"),
        require("../assets/image/home/hospital/5.png"),
        require("../assets/image/home/hospital/6.png"),
        require("../assets/image/home/hospital/7.png"),
        require("../assets/image/home/hospital/8.png"),
        require("../assets/image/home/hospital/1.png"),
        require("../assets/image/home/hospital/9.png"),
        require("../assets/image/home/hospital/10.png"),
        require("../assets/image/home/hospital/11.png"),
        require("../assets/image/home/hospital/12.png"),
      ],
    };
  },
  created() {
    if (document.body.clientWidth < 540) {
      this.lunboLists = [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F3C97C3206ED4A969FCC0123C4845D40-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/1351462659544A4C8A21E0FF759B342A-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/7F1418190671478AA59FA561420D855F-6-2.png",
      ];
    }
  },
  mounted() {
    this.$nextTick(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      });
      wow.init();
      new Swiper(".mySwiper", {
        spaceBetween: 30,
        pagination: ".swiper-pagination",
      });
    });
  },
  methods: {
    // 医院切换
    hospitalChange(id) {
      this.hospitalGL = id;
      if (id === 2) {
        this.partnerMenuList = [
          require("../assets/image/home/hospital/13.png"),
          require("../assets/image/home/hospital/14.png"),
          require("../assets/image/home/hospital/15.png"),
          require("../assets/image/home/hospital/16.png"),
          require("../assets/image/home/hospital/17.png"),
        ];
      } else {
        this.partnerMenuList = [
          require("../assets/image/home/hospital/4.png"),
          require("../assets/image/home/hospital/2.png"),
          require("../assets/image/home/hospital/3.png"),
          require("../assets/image/home/hospital/5.png"),
          require("../assets/image/home/hospital/6.png"),
          require("../assets/image/home/hospital/7.png"),
          require("../assets/image/home/hospital/8.png"),
          require("../assets/image/home/hospital/1.png"),
          require("../assets/image/home/hospital/9.png"),
          require("../assets/image/home/hospital/10.png"),
          require("../assets/image/home/hospital/11.png"),
          require("../assets/image/home/hospital/12.png"),
        ];
      }
    },
    // 合作伙伴切换
    toSwitch(item) {
      this.glID = item.id;
      if (item.title == "government" || this.value == "government") {
        this.partnerMenuList = [
          // require("../assets/image/home/government/1.png"),
          // require("../assets/image/home/government/2.png"),
        ];
      } else if (item.title == "mechanism" || this.value == "mechanism") {
        this.partnerMenuList = [
          require("../assets/image/home/organ/1.png"),
          require("../assets/image/home/organ/2.png"),
          require("../assets/image/home/organ/3.png"),
          require("../assets/image/home/organ/4.png"),
          require("../assets/image/home/organ/5.png"),
          require("../assets/image/home/organ/6.png"),
          require("../assets/image/home/organ/7.png"),
          require("../assets/image/home/organ/8.png"),
        ];
      } else if (item.title == "enterprise" || this.value == "enterprise") {
        this.partnerMenuList = [
          require("../assets/image/home/enterprise/1.png"),
          require("../assets/image/home/enterprise/2.png"),
          require("../assets/image/home/enterprise/3.png"),
          require("../assets/image/home/enterprise/4.png"),
          require("../assets/image/home/enterprise/5.png"),
          require("../assets/image/home/enterprise/6.png"),
          require("../assets/image/home/enterprise/7.png"),
          require("../assets/image/home/enterprise/8.png"),
          require("../assets/image/home/enterprise/9.png"),
        ];
      } else if (item.title == "manufactor" || this.value == "manufactor") {
        this.partnerMenuList = [
          require("../assets/image/home/manufactor/1.png"),
          require("../assets/image/home/manufactor/2.png"),
          require("../assets/image/home/manufactor/3.png"),
          require("../assets/image/home/manufactor/4.png"),
          require("../assets/image/home/manufactor/5.png"),
          require("../assets/image/home/manufactor/6.png"),
          require("../assets/image/home/manufactor/7.png"),
          require("../assets/image/home/manufactor/8.png"),
          require("../assets/image/home/manufactor/9.png"),
          require("../assets/image/home/manufactor/10.png"),
          require("../assets/image/home/manufactor/11.png"),
        ];
      } else if (item.title == "hospital" || this.value == "hospital") {
        this.hospitalGL = 1;
        this.partnerMenuList = [
          require("../assets/image/home/hospital/4.png"),
          require("../assets/image/home/hospital/2.png"),
          require("../assets/image/home/hospital/3.png"),
          require("../assets/image/home/hospital/5.png"),
          require("../assets/image/home/hospital/6.png"),
          require("../assets/image/home/hospital/7.png"),
          require("../assets/image/home/hospital/8.png"),
          require("../assets/image/home/hospital/1.png"),
          require("../assets/image/home/hospital/9.png"),
          require("../assets/image/home/hospital/10.png"),
          require("../assets/image/home/hospital/11.png"),
          require("../assets/image/home/hospital/12.png"),
        ];
      }
    },
    RouterChangeTo(path) {
      this.$router.push({ name: path });
      window.scrollTo(0, 0);
    },
  },
  watch: {
    glID: function (newVal) {
      if (newVal === 1) {
        this.message = "Relevant government units";
      } else {
        this.message = "Partial display";
      }
    },
    value: function (newVal) {
      if (newVal === "government") {
        this.message = "Relevant government units";
      } else {
        this.message = "Partial display";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  .width {
    width: 500px !important;
    @media screen and (max-width: 540px) {
      width: 100% !important;
    }
  }
  .toptwo {
    text-align: left !important;
    padding-left: 1.7021rem !important;
  }
  .maintwo {
    padding-left: 3.4043rem !important;
  }
  #homegl {
    position: relative;
    background-color: #0ca6eb !important;
    .text {
      color: #fff !important;
    }
  }
  #homegl ::after {
    position: absolute;
    bottom: -0.1064rem;
    left: 48%;
    content: "";
    width: 0;
    height: 0;
    border: 0.1064rem solid #0ca6eb;
    border-bottom: none;
    // border-top: none;
    border-left-color: transparent;
    border-right-color: transparent;
    // background-color: #0ca6eb;
  }
  // <!-- 头部大图 -->

  .head-img {
    height: 8.4043rem;
    width: 100%;
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/26CCDB7C99054356B47F169C53D968D1-6-2.png")
      no-repeat;
    background-size: 100% 100%;
    padding-left: 2.0213rem;
    box-sizing: border-box;
    position: relative;
    @media screen and (max-width: 540px) {
      height: 280px;
      background-size: cover;
      background-position: 60% 10%;
      padding-left: 1.0526rem;
    }
    h3 {
      padding: 1.5957rem 0 0.2023rem 0;
      font-size: 0.5149rem;
      width: 50%;
      text-align: left;
      font-weight: 500;
      color: #ffffff;
      margin: 0;
      @media screen and (max-width: 540px) {
        font-size: 1.2632rem;
        width: 60%;
        font-size: 20px;
      }
    }
    h2 {
      font-size: 0.9149rem;
      text-align: left;
      font-weight: 800;
      padding: 0;
      margin: 0;
      color: #ffffff;
      @media screen and (max-width: 540px) {
        font-size: 1.2632rem;
      }
    }
    .Undme {
      cursor: pointer;
      margin-top: 0.7106rem;
      width: 3.5319rem;
      height: 0.9149rem;
      background: rgba(255, 255, 255, 0);
      border: 0.0213rem solid #ffffff;
      border-radius: 0.4787rem;
      font-size: 0.3723rem;
      color: #fff;
      @media screen and (max-width: 540px) {
        width: 5.2632rem;
        height: 1.3579rem;
        border-radius: 0.6842rem;
      }
      span {
        padding-right: 0.6383rem;
      }
    }
    .infobox {
      position: absolute;
      height: 2.6702rem;
      width: 18.3617rem;
      background-color: #fff;
      left: 0;
      bottom: -2.1553rem;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 0.2128rem;
      @media screen and (max-width: 540px) {
        padding-left: 0;
        width: 80%;
        left: 50%;
        margin-left: -40%;
      }
      #one {
        border: none;
      }
      li {
        width: 3.9043rem;
        height: 1.5426rem;
        text-align: center;
        border-left: 1px solid #e2e2e2;
        h2 {
          font-size: 0.5957rem;
          padding-top: 0.1064rem;
          text-align: center;
          color: #333;
          font-weight: 600;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
          // letter-spacing: -2.13px;
        }
        p {
          font-size: 0.3191rem;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
          color: #0ca6eb;
        }
      }
    }
  }
  // <!-- 淡入展示 -->
  .sketch {
    padding-top: 2.5532rem;
    background-color: #fbfbfb;
    .sketch-box {
      height: 8.8936rem;
      display: flex;
      padding: 15px;
      @media screen and (max-width: 540px) {
        display: block;
        position: relative;
        z-index: 10;
        height: 12.6316rem;
      }
      .sketch-box-img {
        flex: 1;
        height: 100%;
        @media screen and (max-width: 540px) {
          flex: none;
          width: 100%;
          overflow: hidden;
        }
        img {
          width: 100%;
          height: 100%;
          @media screen and (max-width: 540px) {
            height: 120%;
          }
        }
        // background-size: 100% 100%;
      }
      .text2 {
        @media screen and (max-width: 540px) {
          position: absolute;
          width: 50%;
          left: 0;
          top: 0;
          background-color: #ffffff77;
          flex: none;
          z-index: 10;
        }
      }
      .sketch-box-text {
        flex: 1;
        @media screen and (max-width: 540px) {
          position: absolute;
          width: 50%;
          right: 0;
          top: 0;
          background-color: #ffffff77;
          flex: none;
        }
        height: 100%;
        .top2 {
          padding: 1.0638rem 1.7021rem 1.0526rem 0 !important;
        }
        .top {
          padding: 1.0638rem 1.7021rem 1.7021rem 0;
          text-align: right;
          @media screen and (max-width: 540px) {
            padding: 1.0638rem 1.7021rem 0.2021rem 0;
          }
          h2 {
            font-size: 0.5745rem;
            @media screen and (max-width: 540px) {
              font-size: 1.1579rem;
            }
            color: #334046;
            font-weight: 700;
            margin: 0;
            padding-bottom: 0.2128rem;
          }
          p {
            font-size: 0.2553rem;
            color: #dadbdb;
            @media screen and (max-width: 540px) {
              font-size: 0.5263rem;
            }
          }
        }
        .main2 {
          @media screen and (max-width: 540px) {
            padding-right: 1.7021rem;
            padding-left: 0;
            text-align: right;
          }
        }
        .main {
          padding-bottom: 1.7021rem;
          padding-left: 1.7021rem;
          font-size: 0.4681rem;
          color: #272b2d;
          line-height: 0.8511rem;
          @media screen and (max-width: 540px) {
            font-size: 0.9474rem;
            line-height: 1.2632rem;
            font-weight: 500;
            padding-bottom: 1.0021rem;
          }
        }
        .bottom {
          text-align: right;
          padding-right: 1.7021rem;
          button {
            cursor: pointer;
            list-style: none;
            width: 2.5532rem;
            height: 0.7447rem;
            background: rgba(255, 255, 255, 0);
            border: 1px solid #0ca6eb;
            border-radius: 0.0638rem;
            font-size: 0.2553rem;
            @media screen and (max-width: 540px) {
              width: 5.2632rem;
              height: 1.4737rem;
              background-color: #0ca6eb;
              color: #fff;
            }
            color: #0ca6eb;
            i {
              padding-left: 0.766rem;
            }
          }
        }
      }
    }
  }
  // 专家团队
  .team-box {
    .title {
      // height: 3.617rem;
      box-sizing: border-box;
      padding: 1.7021rem 0 0 1.7021rem;
      padding-bottom: 0.9474rem;
      @media screen and (max-width: 540px) {
        padding-left: 0;
        padding-bottom: 0;
      }
      h2 {
        font-size: 0.5745rem;
        color: #334046;
        font-weight: 700;
        margin: 0;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 1.0526rem;
        }
        padding-bottom: 0.2128rem;
      }
      p {
        font-size: 0.2553rem;
        color: #dadbdb;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 0.5263rem;
        }
      }
    }
    .main {
      overflow: hidden;
      .main-left {
        height: 6.5957rem;
        float: left;
        width: 56%;
        img {
          width: 100%;
          height: 100%;
        }
        @media screen and (max-width: 540px) {
          float: none;
          width: 100%;
          height: 10.5263rem;
          padding: 0 15px;
          box-sizing: border-box;
          padding-bottom: 0;
        }
      }
      .main-right {
        height: 6.5957rem;
        float: left;
        width: 44%;
        display: flex;
        @media screen and (max-width: 540px) {
          float: none;
          width: 100%;
          height: 10.4211rem;
          padding: 15px;
          box-sizing: border-box;
          padding-top: 0;
        }
        .gl {
          background-color: #f1f1f1 !important;
        }
        .team-infobox {
          padding-left: 0.3511rem;
          flex: 1;
          background-color: #fbfbfb;
          text-align: left;
          @media screen and (max-width: 540px) {
            text-align: center;
          }
          .icon {
            padding-top: 1.883rem;
            width: 0.4787rem;
            height: 0.4787rem;
            @media screen and (max-width: 540px) {
              margin: auto;
              width: 0.9474rem;
              height: 0.9474rem;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          h3 {
            padding: 0.6383rem 0 0.4255rem 0;
            font-size: 0.4468rem;
            @media screen and (max-width: 540px) {
              font-size: 0.8421rem;
            }
            color: #334046;
            margin: 0;
          }
          p {
            font-size: 0.2979rem;
            color: #666666;
            @media screen and (max-width: 540px) {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  // 核心团队
  .team {
    background-color: #fbfbfb;
    padding-bottom: 1.2632rem;
    .teamcontent {
      padding: 0 3rem;
      text-align: center;
      padding-bottom: 0.8526rem;
      display: flex;
      justify-content: space-between;
      .box {
        box-sizing: border-box;
        position: relative;
        width: 6.7rem;
        img {
          width: 100%;
          height: 100%;
        }
        .tit {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 80px;
          background-color: #0ca6ebd6;
          color: #fff;
          text-align: center;
          line-height: 80px;
          font-size: 22px;
          font-weight: 600;
          span {
            font-size: 20px;
            padding: 0 4px;
            font-weight: 400;
          }
        }
      }
      @media screen and (max-width: 540px) {
        display: none;
      }
      img {
        @media screen and (max-width: 540px) {
          width: 100%;
        }
      }
      h2 {
        font-size: 0.3789rem;
        text-align: center;
        padding-top: 0.5263rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
        }
      }
    }
    .teamcontentIOS {
      padding: 0 15px;
      text-align: center;
      display: none;
      .box {
        margin: 5px 20px;
        box-sizing: border-box;
        height: 210px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .tit {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40px;
          background-color: #0ca6ebd6;
          color: #fff;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-weight: 600;
          span {
            font-size: 15px;
            padding: 0 4px;
            font-weight: 400;
          }
        }
      }
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
    .title {
      // height: 3.617rem;
      box-sizing: border-box;
      padding: 1.0526rem 0 0 1.7021rem;
      padding-bottom: 0.6316rem;
      @media screen and (max-width: 540px) {
        padding-left: 0;
      }
      h2 {
        font-size: 0.5745rem;
        color: #334046;
        font-weight: 700;
        margin: 0;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 1.0526rem;
        }
        padding-bottom: 0.2128rem;
      }
      p {
        font-size: 0.2553rem;
        color: #dadbdb;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 0.5263rem;
        }
      }
    }
    .pclunbo {
      @media screen and (max-width: 540px) {
        display: none;
      }
      /deep/ .el-carousel {
        padding-bottom: 1.0526rem;
      }
      /deep/.el-carousel__container {
        height: 4.6rem;
      }
      /deep/.el-carousel__indicators--horizontal {
        bottom: 50px;
      }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
      }
      /deep/ .el-carousel__arrow--left {
        left: 8%;
      }
      /deep/ .el-carousel__arrow--right {
        right: 8%;
      }
      .el-carousel__item {
        overflow: hidden;
        display: flex;
        height: 3.8rem;
        padding-bottom: 0.7263rem;
        justify-content: center;
        .pic {
          position: relative;
          width: 70%;
          height: 100%;
          box-sizing: border-box;
          margin: 0 0.0842rem;
          h2 {
            text-align: center;
            font-size: 0.2737rem;
          }
          img {
            width: 100%;
            height: 98%;
          }
          .txtbox {
            position: absolute;
            bottom: -0.6316rem;
            width: 80%;
            left: 10%;
            background: url("../assets/image/home/team/bg.webp") no-repeat;
            background-size: 100% 100%;
            height: 1.3684rem;
            .allbox {
              width: 100%;
              height: 100%;
              p {
                padding: 0.1684rem 0 0.1474rem 0;
                color: #272b2d;
                text-align: center;
                font-size: 0.3158rem;
              }
              h2 {
                color: #0ca6eb;
                text-align: center;
                font-size: 0.3158rem;
                margin: 0;
              }
            }
            .box {
              h2 {
                font-size: 0.2737rem;
                color: #272b2d;
                text-align: center;
                span {
                  color: #0ca6eb;
                  padding: 0 0.1895rem;
                }
              }
              p {
                color: #272b2d;
                text-align: center;
                font-size: 0.1895rem;
                @media screen and (max-width: 540px) {
                  font-size: 12px;
                }
              }
            }
          }
        }

        .pic1 {
          margin-left: -3.1579rem;
        }
        .pic4 {
          margin-right: -3.1579rem;
        }
      }
      /deep/.el-carousel__button {
        background-color: #e8e8e8;
        height: 0.1053rem;
        width: 0.3158rem;
      }
      /deep/ .is-active {
        button {
          background-color: #0ca6eb;
        }
      }
    }
    .ioslunbo {
      display: none;
      padding: 0 15px;
      position: relative;
      overflow: hidden;
      @media screen and (max-width: 540px) {
        display: block;
        margin-top: 20px;
      }
      .swiper {
        width: 100%;
        height: 100%;
        padding-bottom: 30px;
      }

      .swiper-slide {
        text-align: center;
        font-size: 18px;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .swiper-pagination {
        bottom: 0px;
        /deep/ .swiper-pagination-bullet {
          width: 11px !important;
          height: 11px !important;
        }
      }

      .pic {
        position: relative;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        margin: 0 0.0842rem;
        .title {
          font-size: 18px;
          text-align: center;
          font-weight: 600;
        }
        .image {
          display: flex;
          flex-wrap: wrap;
          // justify-content: center;
          li {
            position: relative;
            height: 210px;
            flex-basis: 50%;
            padding: 5px;
            box-sizing: border-box;
            img {
              width: 100%;
              height: 100%;
            }
            .tit {
              position: absolute;
              bottom: 5px;
              left: 5px;
              width: 95%;
              height: 30px;
              background-color: #0ca6ebd6;
              color: #fff;
              text-align: center;
              line-height: 30px;
              font-size: 12px;
              font-weight: 600;
              span {
                font-size: 12px;
                padding: 0 4px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
  // 合作伙伴
  .partner {
    background-color: #fbfbfb;
    .title {
      height: 3.617rem;
      box-sizing: border-box;
      padding: 1.7021rem 0 0 1.7021rem;
      @media screen and (max-width: 540px) {
        height: 5.2632rem;
        text-align: center;
        padding-left: 0;
      }
      h2 {
        font-size: 0.5745rem;
        color: #334046;
        font-weight: 700;
        margin: 0;
        padding-bottom: 0.2128rem;
        @media screen and (max-width: 540px) {
          font-size: 1.0526rem;
        }
      }
      p {
        font-size: 0.2553rem;
        color: #dadbdb;
        @media screen and (max-width: 540px) {
          font-size: 0.5263rem;
        }
      }
    }
    .partner-menu {
      padding: 0.2128rem 0 0.617rem 0;
      .select-menu {
        display: none;
        @media screen and (max-width: 540px) {
          display: flex;
          justify-content: center;
        }
      }
      ul {
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 540px) {
          display: none;
        }
        li {
          width: 2.766rem;
          border-radius: 6px;
          height: 0.8298rem;
          display: flex;
          border: 1px solid #eaeaea;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin: 0 0.266rem;
          .icon {
            height: 0.3936rem;
            padding-right: 0.1064rem;
            width: 0.3404rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text {
            color: #666666;
            font-size: 0.303rem;
          }
        }
      }
    }
    .PCpage {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .gl {
        background-color: #0ca6eb;
        color: #fff;
      }
      span {
        display: block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #eee;
        text-align: center;
        cursor: pointer;
        margin: 0 5px;
        border-radius: 4px;
      }
      // span:hover{
      //     background-color: #eee;
      //   }
    }
    .partner-box {
      padding: 0 1.5957rem;
      overflow: hidden;
      li {
        // flex: 25%;.
        background-color: #fff;
        float: left;
        overflow: hidden;
        width: 3.9362rem;
        height: 1.4043rem;
        border: 1px solid #eeeeee;
        // text-align: center;
        // line-height: 2rem;
        margin: 0.0851rem;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: 540px) {
          width: 46%;
          height: 3.1579rem;
          margin: 0.2105rem;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .bufen {
      padding: 0.4211rem 0 1.0316rem 0;
      text-align: center;
      color: #999999;
      font-size: 0.3158rem;
    }
  }
  // 底部标语
  .footer-title {
    height: 2.1579rem;
    width: 100%;
    background: url("../assets/image/home/footer.webp") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 540px) {
      height: 5.2632rem;
    }
    .title {
      text-align: center;
      // padding: 0.3936rem 0;
      box-sizing: border-box;
      border: 2px solid #ffffff;
      background: rgba(255, 255, 255, 0.06);
      font-size: 0.2979rem;
      // height: 1.0638rem;
      line-height: 1.0638rem;
      padding: 0 0.5263rem;
      color: #fff;
      // width: 7.0213rem;
      border-color: rgba(255, 255, 255, 0.6);
      @media screen and (max-width: 540px) {
        font-size: 0.7158rem;
        padding: 0.8421rem;
      }
    }
  }
  // 资质荣誉
  .zizhi {
    background: url("../assets/image/home/bg.webp") no-repeat;
    background-size: 100% 100%;
    padding: 0 1.6842rem;
    padding-bottom: 2.1053rem;
    @media screen and (max-width: 540px) {
      padding: 0;
    }
    .title {
      padding: 1.6842rem 0 1.4737rem 0;
      @media screen and (max-width: 540px) {
        text-align: center;
      }
      h3 {
        color: #334046;
        font-size: 0.5684rem;
        padding-bottom: 0.2105rem;
        margin: 0;
        @media screen and (max-width: 540px) {
          font-size: 25px;
        }
      }
      p {
        font-size: 0.2526rem;
        color: #dadbdb;
      }
    }
    .lunboios {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      margin: 0 auto;
      width: 100%;
      height: 220px;
      padding-bottom: 50px;
      .el-carousel__item {
        text-align: center;
      }
      .el-carousel__item img {
        height: 99%;
        width: 40%;
        @media screen and (max-width: 540px) {
          width: 90%;
        }
      }
      // /deep/ .el-carousel__item--card {
      //   width: 2.6947rem;
      // }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
        @media screen and (max-width: 540px) {
          height: 25px;
          width: 25px;
        }
      }
      /deep/ .el-carousel--horizontal {
        padding: 0 50px;
      }
      /deep/ .el-carousel__arrow--left {
        left: -50px;
      }
      /deep/ .el-carousel__arrow--right {
        right: -50px;
      }
      /deep/ .el-carousel__container {
        height: 3.8105rem;
        @media screen and (max-width: 540px) {
          height: 200px;
          // width: 80%;
        }
      }
      /deep/ .el-carousel__item {
        left: -25px;
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        @media screen and (max-width: 540px) {
          width: 15px;
          height: 5px;
        }
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        @media screen and (max-width: 540px) {
          padding: 0 5px;
        }
        padding-top: 1.0526rem;
      }
    }
    .lunbo {
      position: relative;
      height: 5.4211rem;
      // margin-bottom: 2.1053rem;
      @media screen and (max-width: 540px) {
        display: none;
        height: 270px;
        padding-bottom: 30px;
      }
      .el-carousel__item img {
        height: 100%;
        width: 100%;
      }
      /deep/ .el-carousel__container {
        height: 90%;
      }
      /deep/ .el-carousel__item {
        width: 100%;
      }
      /deep/ .el-carousel {
        padding: 0 0.8211rem;
        @media screen and (max-width: 540px) {
          padding: 0 20px;
        }
      }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
        @media screen and (max-width: 540px) {
          width: 25px;
          height: 25px;
        }
      }
      /deep/ .el-carousel--horizontal {
        height: 100%;
      }
      /deep/ .el-carousel__arrow--left {
        left: -0.7895rem;
        @media screen and (max-width: 540px) {
          left: -20px;
        }
      }
      /deep/ .el-carousel__arrow--right {
        right: -0.7895rem;
        @media screen and (max-width: 540px) {
          right: -20px;
        }
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        background-color: #c3c3c3;
        @media screen and (max-width: 540px) {
          width: 20px;
          height: 4px;
        }
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        @media screen and (max-width: 540px) {
          padding: 0 4px;
        }
        padding-top: 0.3158rem;
      }
      // swiper轮播区
      .swiper-container {
        width: 100%;
        height: 100%;
        position: initial;
      }
      .swiper-button-next {
        background-image: none;
        // padding-left: 0.2105rem;
        box-sizing: border-box;
        right: 0.1053rem;
      }
      .swiper-button-prev {
        background-image: none;
        left: 0.1053rem;
      }
      .swiper-button-next,
      .swiper-button-prev {
        width: 0.5263rem;
        height: 0.5263rem;
        border: 2px solid #c6c6c6;
        border-radius: 0.2737rem;
        // line-height: 0.5263rem;
        font-size: 0.3158rem;
        text-align: center;
        color: #c6c6c6;
      }
      .swiper-slide {
        // background-color: lightblue;
        height: 4.2105rem;
        transform: scale(0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      /deep/.swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);
        transition: all 0.5s;
      }
    }
    .lunbo-ios {
      display: none;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
      .swiper-slide{
        padding: 0 10px;
        box-sizing: border-box;
      }
      .swiper{
        padding-bottom: 30px;
        position: relative;
      }
      /deep/ .swiper-pagination-bullet {
          width: 11px !important;
          height: 11px !important;
        }
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
  }
}
</style>
